<mat-card class="envio-manual-dialog">
  <app-card-header
    [title]="data.comandoNombre"
    subtitle="Confirmación de envío"
    icono="send"
    [botonCerrar]="true"
    (cerrar)="dialogRef.close(false)"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <!-- Cargando jerarquía -->
    @if (cargando()) {
      <div class="cargando">
        <mat-spinner diameter="40"></mat-spinner>
        <span>Calculando luminarias alcanzadas...</span>
      </div>
    }

    @if (!cargando() && resumen(); as r) {
      <app-content-card
        title="Luminarias alcanzadas"
        [icon]="r.elegibles === 0 ? 'warning' : 'lightbulb'"
      >
        <app-button
          card-header-actions
          matType="mat-mini-fab"
          color="neutral"
          icon="visibility"
          tooltip="Ver detalle de las luminarias alcanzadas"
          (click)="verDetalle()"
        ></app-button>

        <div class="resumen-cuerpo">
          <div class="resumen-num" [class.sin-elegibles]="r.elegibles === 0">
            <span class="num">{{ r.elegibles }}</span>
            <span class="den">/ {{ r.total }}</span>
          </div>
          <div class="resumen-text">
            luminarias
            <b>{{ tipoLabel }}</b>
            recibirán el comando
          </div>
        </div>

        @if (r.elegibles === 0) {
          <app-info-banner
            color="red"
            icon="error"
            [closable]="false"
            message="Ninguna luminaria recibirá el comando: todas están reclamadas por un perfil."
          ></app-info-banner>
        } @else {
          <app-info-banner
            color="blue"
            icon="info"
            [closable]="false"
            message="Los valores enviados pasarán a ser la configuración deseada de esas luminarias."
          ></app-info-banner>
        }

        @if (ignoradas().length > 0) {
          <div class="ignoradas-nota">
            <mat-icon>block</mat-icon>
            <span>
              {{ ignoradas().length }} luminaria(s) excluida(s) por jerarquía de
              perfiles. Tocá el ojo para ver el detalle.
            </span>
          </div>
        }
      </app-content-card>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button
      irxBoton="secundario"
      type="button"
      (click)="dialogRef.close(false)"
    >
      Cancelar
    </button>
    <button
      irxBoton="principal"
      type="button"
      [disabled]="cargando() || resumen()?.elegibles === 0"
      (click)="dialogRef.close(true)"
    >
      <mat-icon>arrow_forward</mat-icon>
      Continuar
    </button>
  </mat-card-actions>
</mat-card>
